import * as React from 'react';
import * as _ from 'underscore';

import { Messages } from '../../../codegen/Localize';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { SpaceHeaderWithTotalItemsCount } from '../Header/SpaceHeaderWithTotalItemsCount';

export interface AllCollectionsSpaceOwnProps extends ReactDirectiveProps {}

export interface AllCollectionsSpaceAngularProps {
  readonly browserTitleService: BrowserTitleService;
  readonly telemetry: Telemetry;
}

export interface AllCollectionsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedCollections: number;
}

export interface AllCollectionsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type AllCollectionsSpaceNonAngularProps = AllCollectionsSpaceOwnProps & AllCollectionsSpaceStateProps & AllCollectionsSpaceDispatchProps;
export type AllCollectionsSpaceProps = AllCollectionsSpaceAngularProps & AllCollectionsSpaceNonAngularProps;

export class AllCollectionsSpace extends React.PureComponent<AllCollectionsSpaceProps> {
  public componentDidMount() {
    this.props.browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.collections() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.collectionsSpaceLabel()}
          testId={'collections'}
          count={this.props.numberOfFetchedCollections}
          countUpToDate={!this.props.isBusyFetchingItems}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['list']}
            telemetry={this.props.telemetry}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
            }}
            emptyStateProps={{
              primaryMessage: Messages.collectionsEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  }
}
